/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import type DiabguideRecommendation from "parog-web/models/diabguide-recommendation";
import DiabguideRecommendationComputedJournalEvent from "parog-web/models/diabguide-recommendation-computed-journal-event";

export default class DiabguideEditionFormComponent extends CrudJournalEventBaseComponent {
  static forcDisplayName: "Recommandations Diabguide";
  static fullComponentId: "diabguide-recommendation/edition-form";
  static journalEventClass = DiabguideRecommendationComputedJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  get datas(): DiabguideRecommendation {
    return this.changeset.data["data"];
  }
}
